// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  ProbeKind,
} from "./types";


export default __t.row({
  key: __t.string().primaryKey(),
  env: __t.string(),
  group: __t.string(),
  name: __t.string(),
  description: __t.string(),
  sort: __t.u32(),
  probeUrl: __t.string().name("probe_url"),
  get probeKind() {
    return ProbeKind.name("probe_kind");
  },
});
